const SHORT_LABELS: Record<string, string> = {
  'Manufacturer Refurbished or Unopened': 'Open Box/Refurb',
};

export function getConditionShortLabel(
  condition: string | null | undefined,
): string {
  if (!condition) return '';
  return SHORT_LABELS[condition] ?? condition;
}
